module.exports = __webpack_public_path__ + "static/media/logo-gabetti-tec.e6c3fc97.jpg";